import React from 'react';

const LineSeperator = (props) => {
    return (
        <div className="line30"></div>
    );
};

export default LineSeperator;
